import React, { useState } from "react";
import { getColorHex } from "../blockTypeConstants";
import "../../DealApproval.scss";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import { isValidMeaningfulData } from "../helpers";

const ProgressBarForm = ({ itemIndex, blockItem, barColorOptions = [], onUpdateBlockItem, onDeleteBlockItem }) => {
    const [labelError, setLabelError] = useState("");
    const defaultBarColor = barColorOptions[0]?.optionValue || "";
    const colorHex = getColorHex(blockItem.barColor || defaultBarColor, barColorOptions);
    const progressValue = Number(blockItem.value) || 50;

    const handleLabelChange = (e) => {
        const value = e.target.value;
        onUpdateBlockItem(itemIndex, "label", value);
        
        const trimmedValue = value.trim();
        let error = "";
        
        if (trimmedValue) {
            if (trimmedValue.length < 3) {
                error = "Progress title must be at least 3 characters.";
            } else if (!isValidMeaningfulData(trimmedValue)) {
                error = "Please enter a valid and meaningful data.";
            }
        }
        
        setLabelError(error);
    };

    return (
        <>
            <div className="metric-header-row">
                <label>Progress Title <span className="required-mark">*</span></label>
                <button
                    type="button"
                    className="card-delete-text-btn"
                    onClick={() => onDeleteBlockItem(itemIndex)}
                >
                    Delete
                </button>
            </div>
            <input
                type="text"
                placeholder="Enter Title for this progress block..."
                value={blockItem.label || ""}
                maxLength={300}
                onChange={handleLabelChange}
                className={labelError ? "input-error" : ""}
            />
            <div className="error-counter-row">
                {labelError ? <p className="form-error-text">{labelError}</p> : <span className="error-placeholder" />}
                <span className="char-counter-text">{(blockItem.label || "").length}/300</span>
            </div>
            {(blockItem.label || "").length >= 300 && <p className="char-limit-note">Max 300 characters reached</p>}
            <div className="card-icon-color-group">
                <label>Progress bar color <span style={{ fontWeight: 400, color: "#6b7280" }}>(Default color is black)</span></label>
                <div className="bullet-color-select-wrap">
                    <span className="bullet-color-swatch" style={{ background: colorHex }} />
                    <CustomSelect
                        className="bullet-color-select"
                        options={barColorOptions.map((opt) => ({ value: opt.optionValue, label: opt.optionLabel }))}
                        value={blockItem.barColor || defaultBarColor}
                        onChange={(value) => onUpdateBlockItem(itemIndex, "barColor", value)}
                    />
                </div>
            </div>
            <div className="progress-slider-group">
                <div className="progress-slider-header">
                    <label>Value (Dragable)<span className="required-mark">*</span></label>
                    <span className="progress-slider-value">{progressValue}%</span>
                </div>
                <input
                    type="range"
                    className="progress-range-input progress-input"
                    min={0}
                    max={100}
                    value={progressValue}
                    style={{
                        background: (() => {
                            const pct = progressValue;
                            return `linear-gradient(to right, ${colorHex} 0%, ${colorHex} ${pct}%, #e5e7eb ${pct}%, #e5e7eb 100%)`;
                        })(),
                    }}
                    onChange={(e) => onUpdateBlockItem(itemIndex, "value", Number(e.target.value))}
                />
            </div>
        </>
    );
};

export default ProgressBarForm;
